import { useState } from 'react'
import { Button} from 'antd';
import './CandidateInfo.scss';

export const CandidateInfo = ({ applicationAnswers }: { applicationAnswers: { key: string, answer: string }[] | string }) => {
    const [viewMore, setViewMore] = useState(true)
    const answers: { key: string, answer: string }[] = Array.isArray(applicationAnswers)
        ? applicationAnswers
        : (typeof applicationAnswers === 'string' ? JSON.parse(applicationAnswers) : [])

    return (
        <div className="w-full min-w-0 max-w-2xl font-sans">
            <h3 className="mb-2 xs:mb-3 sm:mb-4 text-xs xs:text-sm sm:text-base font-bold text-gray-600">Candidates Info</h3>
            <ul className="candidate-info-list min-w-0 pl-0.5 ml-[.563rem] sm:pl-2 space-y-2.5 xs:space-y-2 sm:space-y-1">
                {answers?.slice(2, viewMore ? answers?.length : 5).map((item, index) => (
                    <li key={index} className="candidate-info-list__item min-w-0 text-xs xs:text-sm sm:text-base leading-relaxed text-gray-600 overflow-hidden">
                        <div className="grid grid-cols-[minmax(4.5rem,7rem)_1fr] xs:grid-cols-[minmax(5.5rem,8rem)_1fr] sm:grid-cols-[minmax(7rem,11rem)_1fr] gap-x-2 xs:gap-x-3 sm:gap-x-4 md:gap-x-1 lg:gap-x-0.5 min-w-0 items-start">
                            <span className="min-w-0 break-words text-gray-600 pt-px sm:pt-0.5 shrink-0">{String(item?.key ?? '').trim()}:</span>
                            <span className="min-w-0 whitespace-pre-wrap break-words text-gray-600">{String(item?.answer ?? '').trim()}</span>
                        </div>
                    </li>
                ))}
            </ul>
            <Button className='p-0 btn-link' onClick={() => { setViewMore(!viewMore) }}>View {`${!viewMore ? 'More' : 'Less'}`}</Button>
        </div>
    )
}
